module.exports = "pegasus/assets/graycircle-linkedin.png";